interface Atividade {
  id: string;
  descricao: string;
  data: string;
  usuario: string;
  tipo: string;
}

interface Props {
  atividades: Atividade[];
}

const tipoConfig: Record<string, { icon: string; color: string; bg: string }> = {
  campo: { icon: "ri-map-pin-line", color: "text-primary-600", bg: "bg-primary-100" },
  cadastro: { icon: "ri-plant-line", color: "text-accent-600", bg: "bg-accent-100" },
  vistoria: { icon: "ri-clipboard-line", color: "text-warning-600", bg: "bg-warning-100" },
  documento: { icon: "ri-file-line", color: "text-secondary-600", bg: "bg-secondary-100" },
  relatorio: { icon: "ri-bar-chart-box-line", color: "text-accent-600", bg: "bg-accent-100" },
  equipe: { icon: "ri-team-line", color: "text-primary-600", bg: "bg-primary-100" },
};

export default function ProjectActivityTimeline({ atividades }: Props) {
  return (
    <div className="relative">
      <div className="absolute left-[15px] top-2 bottom-2 w-px bg-background-200" aria-hidden="true"></div>
      <div className="space-y-3">
        {atividades.map((act, i) => {
          const cfg = tipoConfig[act.tipo] || tipoConfig.campo;
          return (
            <div key={act.id} className="flex items-start gap-3 pl-0 relative">
              <div className={`w-[30px] h-[30px] rounded-full ${cfg.bg} flex items-center justify-center shrink-0 relative z-10`}>
                <i className={`${cfg.icon} ${cfg.color} text-xs`} aria-hidden="true"></i>
              </div>
              <div className="flex-1 min-w-0 pb-3 border-b border-background-100">
                <p className="text-sm text-foreground-800">{act.descricao}</p>
                <p className="text-xs text-foreground-500 mt-1">
                  {act.usuario} · {new Date(act.data).toLocaleDateString("pt-BR")}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}